import { Link } from "react-router-dom";
import { GraduationCap, Award, CalendarCheck, ArrowUpRight, BriefcaseMedical } from "lucide-react";
import { THEME } from "@/data/site";
import { Reveal } from "./Reveal";
import { setBookingDoctor } from "./bookingBus";

export const DoctorProfile = ({ d, flip = false, showDeptLink = true }) => {
  const t = THEME[d.dept];
  return (
    <section data-testid={`doctor-profile-${d.key}`} className={`py-16 md:py-24 ${flip ? "bg-white" : ""}`}>
      <div className="container-x grid items-center gap-12 lg:grid-cols-12">
        <Reveal className={`relative lg:col-span-5 ${flip ? "lg:order-2" : ""}`}>
          <div className={`absolute -inset-3 rounded-[36px] ${t.soft} rotate-[-2deg]`} />
          <div className="relative overflow-hidden rounded-[32px] bg-white">
            <img src={d.photo} alt={d.nameEn} className="h-[440px] w-full object-cover object-top md:h-[520px]" />
            <div className={`absolute bottom-0 left-0 right-0 p-5 text-white ${t.bg}`}>
              <p className="font-display text-2xl">{d.nameHi}</p>
              <p className="font-en text-sm text-white/80">{d.specialtyEn}</p>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Reveal>
            <p className={`eyebrow ${t.text}`}>{t.deptHi} · {t.deptEn}</p>
            <h2 className="font-display mt-3 text-3xl text-ink sm:text-4xl lg:text-5xl">{d.nameHi} <span className="font-en block text-lg text-muted2 sm:inline sm:text-xl">{d.nameEn}</span></h2>
            <p className="mt-2 text-lg font-semibold text-ink/80">{d.specialtyHi}</p>
            <div className="mt-5 flex flex-wrap gap-2 text-sm">
              <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 font-semibold ${t.tint} ${t.text}`}><GraduationCap className="h-4 w-4" /> {d.degreesEn}</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-sand px-3 py-1.5 text-ink/80"><Award className="h-4 w-4" /> {d.fellowships}</span>
            </div>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink/80">{d.bioHi}</p>
            <p className="font-en mt-2 max-w-2xl text-sm text-muted2">{d.bioEn}</p>
          </Reveal>
          <div className="mt-8 grid gap-3 sm:grid-cols-3">
            {d.credentials.map((c, i) => (
              <Reveal key={c.roleEn + i} delay={i * 0.08}>
                <div className="h-full rounded-2xl border border-line bg-white p-4">
                  <BriefcaseMedical className={`h-5 w-5 ${t.text}`} />
                  <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-muted2">{c.roleHi}</p>
                  <p className="mt-1 text-[15px] font-semibold leading-snug text-ink">{c.placeHi}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/#appointment" onClick={() => setBookingDoctor(`${d.nameHi} / ${d.nameEn}`)} data-testid={`doctor-book-${d.key}`} className={`btn ${t.btn}`}><CalendarCheck className="h-4 w-4" /> {d.nameHi} से अपॉइंटमेंट</Link>
            {showDeptLink && <Link to={t.path} data-testid={`doctor-dept-link-${d.key}`} className={`btn btn-outline ${t.text}`}>{t.labelHi} देखें <ArrowUpRight className="h-4 w-4" /></Link>}
          </div>
        </div>
      </div>
    </section>
  );
};
